import React from "react";
import { Globe, Check } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher() {
  const { lang, setLang, languages, t } = useI18n();
  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher-trigger"
          className="inline-flex items-center gap-2 px-3 py-1.5 border border-white/15 hover:border-white/40 text-xs uppercase tracking-[0.18em] text-white/80 transition-colors"
          aria-label={t("lang.label")}
        >
          <Globe className="w-3.5 h-3.5" />
          <span className="font-mono">{current.code.toUpperCase()}</span>
          <span className="hidden sm:inline">{current.flag}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-[#121212] border border-white/10 text-white rounded-none min-w-[180px]"
      >
        <DropdownMenuLabel className="text-xs uppercase tracking-[0.18em] text-white/40 font-normal">
          {t("lang.label")}
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-white/10" />
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`flex items-center justify-between gap-3 cursor-pointer focus:bg-white/5 focus:text-volt ${
              l.code === lang ? "text-volt" : "text-white"
            }`}
          >
            <span className="flex items-center gap-2">
              <span className="text-base">{l.flag}</span>
              <span className="text-sm">{l.label}</span>
            </span>
            {l.code === lang && <Check className="w-4 h-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
